export default {
  title: 'Tilføj kort',
  buttons: {
    save: 'Gem',
  },
  feedback: {
    success: 'Kortet blev gemt',
  },
};
